import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Receipt, ShieldCheck } from "lucide-react";
import PageShell from "../components/sections/PageShell";

// Stripe-hosted no-code Customer Portal login page (live mode).
// Buyer enters their email → Stripe emails a magic link to their portal.
const STRIPE_PORTAL_LOGIN = "https://billing.stripe.com/p/login/5kQ4gz8ef1qc5TB50O5gc00";

const setLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function BillingPortalPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Manage billing — Gadget Guy Media";
    setLink("canonical", "https://gadgetguymedia.com/billing");
  }, []);

  return (
    <PageShell testId="billing-portal-page">
      <section
        className="relative"
        style={{ paddingTop: "clamp(48px, 10vh, 112px)", paddingBottom: "clamp(48px, 8vh, 96px)" }}
      >
        <div className="max-w-2xl mx-auto px-5 md:px-8">
          <div className="ggm-eyebrow mb-6" data-testid="billing-eyebrow">
            Customer · Self-Service
          </div>
          <h1
            className="font-condensed uppercase text-white leading-[1.02]"
            style={{ fontSize: "clamp(2rem, 5.5vw, 3.75rem)", letterSpacing: "-0.015em" }}
            data-testid="billing-h1"
          >
            Manage your billing.
          </h1>
          <p
            className="mt-5 font-body text-white/75 text-base md:text-lg leading-relaxed"
            data-testid="billing-subhead"
          >
            View past coaching purchases, download invoices and receipts, and update
            your card or billing info. Continue to Stripe below and enter the email
            you used at checkout — Stripe will email you a secure sign-in link.
          </p>

          <div className="mt-10 flex flex-wrap gap-3 items-center">
            <a
              href={STRIPE_PORTAL_LOGIN}
              className="ggm-btn-primary"
              data-testid="billing-continue-stripe"
              rel="noopener noreferrer"
            >
              Continue to Stripe <Receipt size={16} />
            </a>
          </div>

          <div className="mt-8 flex items-start gap-2 text-white/50 text-xs max-w-lg">
            <ShieldCheck size={14} className="text-[var(--ggm-signal-cyan)] mt-[2px] shrink-0" />
            <span>
              All billing info is stored securely by Stripe. Portal sessions expire
              after 5 minutes of inactivity. Just finished a purchase? Use the
              &ldquo;Manage billing&rdquo; button on the confirmation page for
              one-click access — no email needed.
            </span>
          </div>

          <div className="mt-12 flex flex-wrap gap-3">
            <Link to="/pricing" className="ggm-btn-secondary" data-testid="billing-cta-pricing">
              Book a coaching hour <ArrowRight size={16} />
            </Link>
            <Link to="/" className="ggm-btn-secondary" data-testid="billing-cta-home">
              Back home <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
